<template>
  <div class="col-md-3" :class="mobile_responsive">
    <div
      v-if="typeof menu === 'object'"
      class="product-detail-box"
      data-target="#customizedDescription"
      data-toggle="modal"
      @click="addToCart(menu)"
    >
      <div class="img-box">
        <label
          v-if="
            parseFloat(Num.price(discounted_menu_price(menu) || menu.value))
          "
        >
          {{ currency }}
          <!-- Num.price(discounted_menu_price(menu) || menu.value, menu.original_value)-->
          <span>{{
            Num.price(discounted_menu_price(menu) || menu.value)
          }}</span>
          <span
            class="orignal-price"
            v-if="
              discounted_menu_price(menu) &&
                Num.price(discounted_menu_price(menu)) !== Num.price(menu.value)
            "
          >
            <del>{{ currency }} {{ Num.price(menu.value) }}</del>
          </span>
        </label>
        <label v-else>
          <span class="orignal-price">{{
            _T('Price Based on Selection')
          }}</span>
        </label>
        <div
          v-if="
            menu.image &&
              menu.image.length &&
              currentBrand.item_layout == 'default'
          "
        >
          <img
            style="display:none;"
            :src="currentImagePath"
            @error="currentImagePath = menu.image"
          />
        </div>
        <div
          v-bind:style="{ 'background-image': 'url(' + currentImagePath + ')' }"
          v-if="currentImagePath"
          class="bg-size"
        ></div>
        <div
          v-else
          v-bind:style="{
            'background-image': `url(/images/no_image_new.jpeg)`,
          }"
          class="bg-size no-image"
        ></div>
      </div>
      <div class="product-details">
        <h5 @click="addToCartMobile(menu)">{{ _T_DB(menu, 'name') }}</h5>
        <!--<h6 class="detail">{{ _T_DB(menu, 'item_type')}}</h6>-->
        <h6
          class="price"
          v-if="
            parseFloat(Num.price(discounted_menu_price(menu) || menu.value))
          "
        >
          {{ currency }}
          {{ Num.price(discounted_menu_price(menu) || menu.value) }}
        </h6>
        <h6 class="price" v-else>
          {{ _T('Price Based on Selection') }}
        </h6>
        <p
          class="orignal-price price"
          v-if="
            parseFloat(Num.price(discounted_menu_price(menu) || menu.value)) &&
              discounted_menu_price(menu) &&
              Num.price(discounted_menu_price(menu)) !== Num.price(menu.value)
          "
        >
          <del>{{ currency }} {{ Num.price(menu.value) }}</del>
        </p>
      </div>
      <div class="cart">
        <a>
          <svg width="56" height="56" fill="none">
            <use xlink:href="#cartW" />
          </svg>
          <h4>{{ _T('Add to cart') }}</h4>
        </a>
      </div>

      <!-- <a
        v-b-modal.MobileCart
        href="javascript:void(0)"
        class="add-btn"
        @click="addToCartMobile(menu)"
        >add</a
      >-->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Windowsize from '@/mixins/Windowsize'
// import { seo_name } from '@/utils/main_utils'
// import * as CONST from '@/constants'
import CartMixin from '@/mixins/CartMixin'
export default {
  name: 'MenuTile',
  props: ['item', 'id'],
  components: {},
  data() {
    return {
      currentImagePath: '',
    }
  },
  mixins: [CartMixin, Windowsize],
  computed: {
    // menu() {
    //   return Object.freeze(this.item)
    // },
    ...mapGetters(['_T', '_T_DB', 'discounted_menu_price', 'currentBrand']),
    ...mapState({
      selectedItem: state => state.cart_store.selectedItem,
      searchItem: state => state.brandstore_store.searchItem,
      openModifierMobile: state => state.brand_store.openModifierMobile,
    }),
    mobile_responsive() {
      if (this.currentBrand) {
        if (this.currentBrand.item_layout === 'default')
          return 'col-xl-2 col-sm-6'
        else return 'col-lg-2 col-6'
      } else return 'col-xl-2 col-sm-6'
    },
  },
  watch: {
    // searchItem() {
    //   this.$nextTick(() => {
    //     this.getImage()
    //   })
    // },
  },
  methods: {
    getImage() {
      if (this.menu) {
        this.currentImagePath = ''
        if (
          this.currentBrand &&
          this.currentBrand.item_layout &&
          this.currentBrand.item_layout == 'square_layout_long'
        ) {
          if (this.menu.images.length != 0) {
            let url = this.menu.images[this.menu.images.length - 1].image.split(
              'menu/'
            )
            this.currentImagePath = url[1]
              ? url[0] + 'menu/large/' + url[1]
              : this.menu.image
            this.currentImagePath = this.currentImagePath.replace('(', '%28')
            this.currentImagePath = this.currentImagePath.replace(')', '%29')
          }
        } else if (
          this.currentBrand &&
          this.currentBrand.item_layout &&
          this.currentBrand.item_layout ==
            'square_layout_long square_layout_mid'
        ) {
          if (this.menu.image) {
            let url = this.menu.image.split('menu/')
            this.currentImagePath = url[1]
              ? url[0] + 'menu/large/' + url[1]
              : this.menu.image
          } else {
            if (this.menu.images.length != 0) {
              let url = this.menu.images[
                this.menu.images.length - 1
              ].image.split('menu/')
              this.currentImagePath = url[1]
                ? url[0] + 'menu/large/' + url[1]
                : this.menu.image
            }
          }
          this.currentImagePath = this.currentImagePath.replace('(', '%28')
          this.currentImagePath = this.currentImagePath.replace(')', '%29')
        } else {
          if (this.menu.image) {
            let url = this.menu.image.split('menu/')
            this.currentImagePath = url[1]
              ? url[0] + 'menu/large/' + url[1]
              : this.menu.image
            this.currentImagePath = this.currentImagePath.replace('(', '%28')
            this.currentImagePath = this.currentImagePath.replace(')', '%29')
          }
        }
      }
    },
  },
  beforeMount() {
    this.getImage()
  },
  beforeDestroy() {
    this.currentImagePath = undefined
    this.menu = undefined
    //this.item = undefined
    this.currentItem = undefined
  },
  created() {
    this.menu = Object.freeze(this.item)
  },
  destroyed() {
    //console.log('componetn destroyed dead', this.id)
  },
  deactivated: function() {
    //console.log('component deactivated, keepalive')
  },
}
</script>

<style lang="scss" scoped>
.custom-padding {
  padding-left: $px30;
  padding-right: $px30;
}
.price-based-selection {
  font-size: 0.839rem !important;
}
.ratio_94 {
  .bg-size {
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    display: block;
    &:before {
      padding-top: 94%;
      content: '';
      display: block;
    }
  }

  /*.no-image {
    background-size: contain !important;
    margin: 5px 16px;
  }*/
}

.product-detail-box {
  border: $px1 solid rgba(var(--color-dark-border-source), 0.44);
  border-radius: $px10;
  overflow: hidden;
  position: relative;
  margin-bottom: $px25;
  &:focus {
    outline: none;
  }
  .img-box {
    position: relative;
    .eye-click {
      width: $px20;
      top: 0;
      position: absolute;
      left: 0;
      height: $px20;
      background-color: rgba(var(--color-white-source), 0.55);
      align-items: center;
      justify-content: center;
      display: none;
      img {
        width: $px13;
      }
    }

    label {
      font-size: $px14;
      line-height: $px17;
      letter-spacing: 0.5px;
      color: $white;
      background-color: $color-primary;
      position: relative;
      margin-bottom: 0;
      top: 0;
      left: 0;
      padding: $px6 $px9;
      width: 100%;
      span {
        font-weight: 600;
        font-size: $px18;
        line-height: $px22;
        letter-spacing: 0.02em;
        &.orignal-price {
          font-size: $px12;
          margin-left: $px7;
        }
      }
    }
  }
  .product-details {
    padding: $px15;

    h5 {
      font-size: calc(
        #{$px14} + (18 - 14) * ((100vw - #{$px320}) / (1920 - 320))
      );
      //max-width: $px220;
      max-width: 100%;
      text-align: center;
      font-weight: bold;
      text-transform: capitalize;
      //margin-bottom: $px10;
      margin-bottom: 0;
      color: $font-color;
    }
    h6 {
      font-weight: normal;
      font-size: $px14;
      line-height: $px17;
      color: $font-color;
      margin-bottom: 0;
    }
    .price {
      display: none;
    }
    .detail {
      text-transform: capitalize;
    }
  }
  .cart {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(var(--color-font-color-source), 0.6);
    text-align: center;
    opacity: 0;
    transform: scale(0);
    transition: all 0.5s ease;
    cursor: pointer;
    a {
      h4 {
        color: $white;
        font-weight: 600;
        font-size: $px18;
        line-height: $px22;
        text-align: center;
        letter-spacing: 0.02em;
        margin-top: $px16;
        text-transform: capitalize;
        margin-bottom: -$px4;
      }
    }
  }
  .add-btn {
    display: none;
    position: absolute;
    right: 0;
    bottom: 0;
    background-color: $color-primary;
    border-radius: $px4;
    color: $white;
    font-style: normal;
    font-weight: 600;
    font-size: $px13;
    line-height: $px16;
    letter-spacing: 0.02em;
    text-transform: capitalize;
    padding: $px4 $px18;
  }
  &:hover {
    .cart {
      opacity: 1;
      transform: scale(1);
      transition: all 0.5s ease;
    }
  }
}
@media (max-width: 1760px) {
  .custom_col {
    .col-xl-2 {
      flex: 0 0 20%;
      max-width: 20%;
    }
  }
}
// @media (min-width: 1200px) {
//   .custom_col {
//     .col-xl-2 {
//       flex: 0 0 20%;
//       max-width: 20%;
//     }
//   }
// }
/*grid view for default*/
@media (max-width: 1199px) {
  .custom_col {
    .col-xl-2 {
      flex: 0 0 33.33%;
      max-width: 33.33%;
    }
  }
  .product-detail-box {
    .img-box {
      label {
        padding: $px4 $px6;
      }
    }
    .cart {
      img {
        width: 40%;
      }
      a {
        h4 {
          margin-top: $px6;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .custom_col {
    .col-xl-2 {
      flex: 0 0 25%;
      max-width: 25%;
    }
  }
}
@media (max-width: 767px) {
  .custom_col {
    .col-xl-2 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
  .product-detail-box {
    display: flex;
    align-items: center;
    border: none;
    border-radius: 0;
    margin-bottom: $px28;
    .img-box {
      width: $px123;
      border-radius: $px4;
      overflow: hidden;
      -webkit-box-ordinal-group: 2;
      -ms-flex-order: 1;
      order: 1;
      margin-left: auto;
      .eye-click {
        display: flex;
      }
      label {
        display: none;
      }
    }
    .product-details {
      width: $px220;
      padding: 0;
      margin-right: $px16;
      h5 {
        margin-bottom: $px10;
        text-align: left;
      }
      .detail {
        display: none;
      }
      .price {
        display: block;
        font-weight: bold;
        font-size: $px13;
        line-height: $px16;
        letter-spacing: 0.02em;
        color: $light-font;
      }
    }
    .cart {
      display: none;
    }
    .add-btn {
      display: block;
    }
    p {
      &.orignal-price {
        font-size: $px12;
      }
    }
  }
}
/*grid view for default*/
.square_layout_long .bg-size {
  height: 490px;
}
.square_layout_mid .bg-size {
  height: auto;
}
.square_layout_long .product-details {
  text-align: center;
}
.square_layout_long .product-details h5 {
  max-width: 100% !important;
}
.square_layout_long .img-box label {
  display: none;
}
.square_layout_long .product-details .price {
  display: block !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
}
.square_layout_long .product-details h5 {
  max-width: 100%;
  min-height: 38px;
  text-align: center;
}
//.square_layout_long .bg-size{background-size: 100%;} //uncomment this if contain fit for all images
.square_layout_long .no-image {
  background-size: 100%;
} //comment this if want to full image

@media (max-width: 1440px) {
  .square_layout_long .bg-size {
    height: 362px;
  }
  .square_layout_mid .bg-size {
    height: auto;
  }
}

@media (max-width: 1280px) {
  .square_layout_long .bg-size {
    height: 304px;
  }
  .square_layout_mid .bg-size {
    height: auto;
  }
}

@media (max-width: 990px) {
  .square_layout.row {
    margin: 0 -10px;
  }
  .square_layout_long .col-6 {
    padding: 0 10px;
  }
}
@media (max-width: 767px) {
  .square_layout_long .product-detail-box {
    border: 0.0625rem solid rgba(var(--color-dark-border-source), 0.44);
    display: block !important;
  }
  .square_layout_long .img-box {
    width: 100% !important;
    margin-left: 0 !important;
    border-radius: 0.25rem 0.25rem 0 0 !important;
  }
  .square_layout_long .product-details {
    width: 100% !important;
    margin-right: 0 !important;
    padding: 0.9375rem 0 !important;
  }
  .square_layout_long .product-details .price {
    color: var(--color-font-color) !important;
  }
  .square_layout_long .bg-size {
    height: 490px;
  }
  .square_layout_mid .bg-size {
    height: auto;
  }
}

@media (max-width: 668px) {
  .square_layout_long .bg-size {
    height: 400px;
  }
  .square_layout_mid .bg-size {
    height: auto;
  }
}

@media (max-width: 568px) {
  .square_layout_long .bg-size {
    height: 375px;
  }
  .square_layout_mid .bg-size {
    height: auto;
  }
}

@media (max-width: 480px) {
  .square_layout_long .bg-size {
    height: 312px;
  }
  .square_layout_mid .bg-size {
    height: auto;
  }
}

@media (max-width: 380px) {
  .square_layout_long .bg-size {
    height: 220px;
  }
  .square_layout_mid .bg-size {
    height: auto;
  }
}
.body-rtl {
  .product-detail-box {
    .product-details {
      > h5 {
        text-align: right;
      }
      text-align: right;
    }
    .img-box {
      label {
        text-align: right;
      }
    }
  }
}
</style>
